import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'

type PagingProps = {
  page: number
  setPage: (v: number) => void
  limit?: number
  /**
   * 全件数。BE が total を返す画面のみ指定。未指定のときは件数行を出さない。
   */
  total?: number
  /**
   * total 未指定時のみ使用。次ページがあり得るか（例: 現在ページの件数が limit 以上）。
   */
  hasNextPage?: boolean
  isDisabled?: boolean
  onChange?: (page: number) => void
}

export const AccommodationPaging: React.FC<PagingProps> = ({
  page,
  setPage,
  limit = 50,
  total,
  hasNextPage = false,
  isDisabled = false,
  onChange,
}) => {
  const { t } = useTranslation()

  const hasTotal = typeof total === 'number'

  const currentRange = (): { start: number; end: number } => {
    const tnum = hasTotal ? total : 0
    return {
      start: 1 + (page - 1) * limit,
      end: Math.min(page * limit, tnum),
    }
  }

  const hasPrev = (): boolean => {
    return page > 1
  }

  const hasNext = (): boolean => {
    if (hasTotal) return currentRange().end !== total
    return hasNextPage
  }

  const rowCountLabel = hasTotal
    ? `${total === 0 ? '0 / 0' : `${currentRange().start}-${currentRange().end} / ${total}`} ${t('Rows')}`
    : null

  return (
    <>
      <div css={pagingWrapperStyle}>
        {rowCountLabel != null ? <p>{rowCountLabel}</p> : null}
        {hasPrev() && !isDisabled ? (
          <img
            onClick={() => {
              setPage(page - 1)
              onChange && onChange(page - 1)
            }}
            src={require('@/static/images/arrow_left.svg')}
            css={pagingStyle}
          />
        ) : (
          <img src={require('@/static/images/arrow_disabled_left.svg')} css={disabledPagingStyle} />
        )}
        {hasNext() && !isDisabled ? (
          <img
            onClick={() => {
              setPage(page + 1)
              onChange && onChange(page + 1)
            }}
            src={require('@/static/images/arrow_right.svg')}
            css={pagingStyle}
          />
        ) : (
          <img src={require('@/static/images/arrow_disabled_right.svg')} css={disabledPagingStyle} />
        )}
      </div>
    </>
  )
}

const pagingWrapperStyle = css({
  fontWeight: 'bold',
  fontSize: 12,
  lineHeight: '23px',
  color: '#676767',
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  marginLeft: 24,
  p: {
    margin: 0,
    whiteSpace: 'nowrap',
  },
  img: {
    width: 30,
    height: 30,
  },
})

const pagingStyle = css({
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: '#f2f2f2',
    borderRadius: '50%',
  },
})

const disabledPagingStyle = css({
  '&:hover': {
    cursor: 'defalut',
  },
})
